export const MEDIA_375 = 375
export const MEDIA_599 = 599
export const MEDIA_600 = 600
export const MEDIA_767 = 767
export const MEDIA_768 = 768
export const MEDIA_1239 = 1239
export const MEDIA_1240 = 1240
export const MEDIA_1439 = 1439
export const MEDIA_1440 = 1440
export const MEDIA_1639 = 1639
export const MEDIA_1640 = 1640
export const MEDIA_1919 = 1919
export const MEDIA_1920 = 1920

export const MEDIA_SIZES = [
  MEDIA_375,
  MEDIA_599,
  MEDIA_600,
  MEDIA_767,
  MEDIA_768,
  MEDIA_1239,
  MEDIA_1240,
  MEDIA_1439,
  MEDIA_1440,
  MEDIA_1639,
  MEDIA_1640,
  MEDIA_1919,
  MEDIA_1920,
] as const

export type MediaSize = (typeof MEDIA_SIZES)[number]
